module.exports = __webpack_public_path__ + "img/Triangle.70044775.svg";